import noop from "lodash.noop";
import { call, takeEvery } from "redux-saga/effects";
import {
    BACKUP_REQUESTED,
    backupRequested,
    backupSucceeded,
    backupFailed,
    RESTORE_REQUESTED,
    restoreRequested,
    restoreSucceeded,
    restoreFailed,
    defaultScopeId,
    RESET_REQUESTED,
    resetRequested,
    resetSucceeded,
    resetFailed,
} from "./data.duck";
import { backupData, restoreData, resetData } from "./data.api";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        backupRequested,
        backupSucceeded,
        backupFailed,
        restoreRequested,
        restoreSucceeded,
        restoreFailed,
        resetRequested,
        resetSucceeded,
        resetFailed,
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    {
        backupData,
        restoreData,
        resetData
    },
    injectBoundGQLClient
);

export function* backupDataSaga({
    api: { backupData },
    actions: { backupSucceeded, backupFailed },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield backupData();
        yield backupSucceeded(result);
        yield call(resolve);
    } catch (e) {
        yield backupFailed(e);
        yield call(reject, e);
    }
}

export function* restoreDataSaga({
    api: { restoreData },
    actions: { restoreSucceeded, restoreFailed },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield restoreData();
        yield restoreSucceeded(result);
        yield call(resolve);
    } catch (e) {
        yield restoreFailed(e);
        yield call(reject, e);
    }
}

export function* resetDataSaga({
    api: { resetData },
    actions: { resetSucceeded, resetFailed },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield resetData();
        yield resetSucceeded(result);
        yield call(resolve);
    } catch (e) {
        yield resetFailed(e);
        yield call(reject, e);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(
            BACKUP_REQUESTED,
            withApiContext(withBoundActions(backupDataSaga))
        );
        yield takeEvery(
            RESTORE_REQUESTED,
            withApiContext(withBoundActions(restoreDataSaga))
        );
        yield takeEvery(
            RESET_REQUESTED,
            withApiContext(withBoundActions(resetDataSaga))
        );
    };
